import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Switch, message, Alert } from "antd";

import { req_edit_lrs_spaceSessionTimeStandard } from "../../api";
import storageUtils from "../../utils/storageUtils";

class SpaceModalSessionTime extends Component {
  // 基礎通用參數 //////////////////////////////////////////////

  state = {
    space: {},
    department: [],
    showSessionTimeStyle: "TIME",
  };

  static propTypes = {
    space: PropTypes.object.isRequired,
    sessiondates: PropTypes.array.isRequired,
    sessiontimes: PropTypes.array.isRequired,
  };

  // 遠端數據處理 //////////////////////////////////////////////

  api_modify_item = async (item) => {
    //console.log(item);
    const result = await req_edit_lrs_spaceSessionTimeStandard(
      item,
      storageUtils.getUser().token
    );
    if (result.status === "success") {
      // message.success(result.message);
    } else {
      message.error(result.message);
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  getDayOfWeek = (date) => {
    const dayOfWeek = date;
    //console.log(dayOfWeek)
    return isNaN(dayOfWeek)
      ? null
      : [
          "",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
          "星期日",
        ][dayOfWeek];
  };
  // 操作互動處理 //////////////////////////////////////////////
  handle_change = (value, data) => {
    const { Uid, RoomCode } = data;
    const item = {
      DefaultStatus: value === true ? "OPEN" : "CLOSE",
      Uid: Uid,
      RoomCode: RoomCode,
      condition: "BASE",
    };
    this.api_modify_item(item);
  };

  handleSwitchChange = (checked) => {
    checked
      ? this.setState({ showSessionTimeStyle: "TIME" })
      : this.setState({ showSessionTimeStyle: "SESSION" });
  };
  ////////////////////////////////////////////////////////////

  render() {
    const { space, sessiondates, sessiontimes } = this.props;
    const { showSessionTimeStyle } = this.state;
    const listSessions =
      sessiondates.length > 0 ? (
        <>
          {sessiondates.sort().map((item) => (
            <div
              className="col-sm"
              key={item}
              style={{ margin: "0px", padding: "0px" }}
            >
              <Card
                style={{
                  fontSize: "1.1em",
                  textAlign: "center",
                }}
                key={item}
              >
                <div style={{ fontWeight: "bold" }}>
                  <div>{this.getDayOfWeek(item)}</div>
                </div>
                <>
                  {sessiontimes
                    .filter((sessiontime) => sessiontime.WeekCode === item)
                    .map((data) => (
                      <>
                        <Switch
                          key={data.TimeStart + data.TimeEnd}
                          size="small"
                          checkedChildren={
                            showSessionTimeStyle === "TIME" ? (
                              <>
                                開-{data.TimeStart}-{data.TimeEnd}
                              </>
                            ) : (
                              <>開-{data.TimeName}</>
                            )
                          }
                          unCheckedChildren={
                            showSessionTimeStyle === "TIME" ? (
                              <>
                                關-{data.TimeStart}-{data.TimeEnd}
                              </>
                            ) : (
                              <>關-{data.TimeName}</>
                            )
                          }
                          defaultChecked={
                            data.DefaultStatus === "CLOSE" ? false : true
                          }
                          onChange={(value) => this.handle_change(value, data)}
                        />
                      </>
                    ))}
                </>
              </Card>
            </div>
          ))}
        </>
      ) : (
        ""
      );
    return (
      <Card>
        <Alert
          message={
            <div style={{ color: "red", fontSize: "1.3em" }}>
              {space.BuildingName}-({space.RoomCode}){space.RoomTwName}
              <Switch
                checkedChildren="顯示時段"
                unCheckedChildren="顯示節次"
                defaultChecked={showSessionTimeStyle === "TIME" ? true : false}
                onChange={this.handleSwitchChange}
              />
            </div>
          }
          type="success"
        />
        <div className="row">{listSessions}</div>
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SpaceModalSessionTime);
